import { GetBy } from "../_app/cuchillo/core/Element";
import Wave from "./Wave";
import { WaveCircle } from './WaveCircle';

export class Waves {
    static _tick = 0;
    static _waves = [];

    static init() {
        [...GetBy.class('__divider')].map(dom => {
            const wave = new Wave(dom);
            this._waves.push(wave);
        });

        [...GetBy.class('__circle')].map(dom => {
            const wave = new WaveCircle(dom);
            this._waves.push(wave);
        });
    }

    static loop() {
        this._tick++;
        this._waves.map(item => item.loop(this._tick));
    }

    static dispose() {
        this._waves.map(item => item.dispose());
        this._waves = [];
        this._tick = 0;
    }

    static resize() {
        this._waves.map(item => item.resize());
    }
}
